<template>
  <question-card
    class="refinancing-reason-step"
    hide-button
  >
    <template #title>
      {{UIComponentData.Header.Translations[questionnaireLead.Language]}}
    </template>
    <answer-icon-block>
      <answer-icon
        @click="answer(answers.term)"
        image="change_term.svg"
        :checked="questionnaireLead.RefinaceReason === answers.term"
      >
        {{UIComponentData.Choice1.Translations[questionnaireLead.Language]}}
      </answer-icon>
      <answer-icon
        @click="answer(answers.cacheOut)"
        image="cash_out.svg"
        :checked="questionnaireLead.RefinaceReason === answers.cacheOut"
      >
        {{UIComponentData.Choice2.Translations[questionnaireLead.Language]}}
      </answer-icon>
    </answer-icon-block>
  </question-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { ANSWERS } from '@/utils/constants/common';
import QuestionCard from '@/components/QuestionCard.vue';
import AnswerIconBlock from '@/components/AnswerIconBlock.vue';
import AnswerIcon from '@/components/AnswerIcon.vue';

export default {
  name: 'refinancing-reason-step',
  components: {
    QuestionCard,
    AnswerIconBlock,
    AnswerIcon,
  },
  data: () => ({
    answers: ANSWERS.RefinaceReason,
  }),
  props: {
    UIComponentData: {
      type: Object,
      required: true
    },
    UIId: Number
  },
  methods: {
    ...mapActions(['mutateLead']),
    async answer(value) {
      this.questionnaireLead.RefinaceReason = value;
      if(this.UIId!=null){
        if(this.questionnaireLead.StepId==null||this.UIId > this.questionnaireLead.StepId){
          this.questionnaireLead.StepId = this.UIId
          this.mutateLead(this.questionnaireLead);
          this.$emit('route-to-next-slide',true);
        }
        else{
          this.$emit('route-to-next-slide',false);
        }
      }
    },
  },
  computed: {
    ...mapGetters(['questionnaireLead']),
  }
};
</script>
